#import "../../session-assignation/graphql/sessionCrudResult.fragment.graphql"

mutation applyAssignmentProposal(
  $scenarioId: ID!
  $originId: ID!
  $input: ApplyAssignmentProposalInput!
) {
  cube(scenarioId: $scenarioId, originId: $originId) {
    applyAssignmentProposal(input: $input) {
      errorCode
      proposalId
      state
      status
      unsupportedSessionId
      validation {
        ...SessionCrudResultFields
        __typename
      }
      __typename
    }
    __typename
  }
}
